import { removeLocalContentCopies } from './apiRemoveLocalContentCopies';
import { useMutation } from '@tanstack/react-query';

export const useRemoveLocalContentCopies = () => {
    return useMutation(removeLocalContentCopies);
};
